import { render, staticRenderFns } from "./RbxRemoteCombobox.vue?vue&type=template&id=45a44963&"
import script from "./RbxRemoteCombobox.vue?vue&type=script&lang=js&"
export * from "./RbxRemoteCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RbxRemoteCombobox.vue"
export default component.exports